import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const LoginPage: React.FC = () => {
  const { signIn } = useAuth();
  const { theme } = useTheme();

  const handleSignIn = () => {
    signIn();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-zinc-50 dark:bg-zinc-900 px-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="mb-10 flex flex-col items-center">
          <div className="mb-6 flex items-center justify-center bg-white dark:bg-zinc-800 rounded-2xl p-8 border border-zinc-200 dark:border-zinc-700 shadow-sm">
            <img
              src={theme === 'dark' ? "/images/novax-logo.png" : "/images/novax-logo-black.png"}
              alt="novaX Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
          <h2 className="text-xl font-medium text-zinc-900 dark:text-zinc-100 mb-2">
            Welcome to the Garden
          </h2>
          <p className="text-sm text-zinc-500 dark:text-zinc-400 text-center max-w-sm">
            Power Digital's repository for AI capabilities and training
          </p>
        </div>

        {/* Sign in card */}
        <div className="relative">
          <div className="bg-white dark:bg-zinc-900/50 rounded-xl p-8 border border-zinc-200 dark:border-zinc-700 shadow-sm">
            <button
              onClick={handleSignIn}
              className="w-full flex items-center justify-center bg-white dark:bg-zinc-800 border border-zinc-200 dark:border-zinc-600 rounded-lg px-6 py-3.5 hover:bg-zinc-50 dark:hover:bg-zinc-700 hover:border-zinc-300 dark:hover:border-zinc-500 focus:outline-none focus:ring-2 focus:ring-teal-500/30 transition-all group"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" fill="none">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              <span className="text-sm font-medium text-gray-900 dark:text-white">
                Sign in with Google
              </span>
            </button>
            
            <p className="mt-6 text-xs text-gray-500 dark:text-gray-600 text-center leading-relaxed">
              By signing in with Google, you authorize us to access your Google account for authentication purposes only
            </p>
          </div>
        </div>

        <footer className="mt-8 text-xs text-gray-500 dark:text-gray-700 text-center">
          © {new Date().getFullYear()} Power Digital. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default LoginPage; 